import select from 'dom-select';
import { setCookie } from '../../../js/lib/cookies';

const COOKIE_NAME = 'win_cc';
const ACCEPTED = '89';

export const CookieConsent = (el) => {
  const ui = {
    el,
    body: select('body', document),
    consentBtn: select('#cookie-consent-btn', document),
  };

  // console.log(ui);

  const addEvents = () => {
    ui.consentBtn.addEventListener('click', () => {
      ui.el.classList.add('dismissed');
      setCookie(COOKIE_NAME, ACCEPTED, 30);
    });
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default CookieConsent;
